/**
 * Декоратор для пометки полей, которые нужно исключить из сериализации.
 * При вызове toJSON() такие поля не попадут в результирующий объект.
 *
 * @example
 * class Product {
 *     @noSerialize
 *     internalCache: HeavyObject;
 * }
 */

function NoSerialize(target: any, propertyKey: string): void {
	// Проверяем собственное поле класса, а не унаследованное по прототипу,
	// иначе поля наследника попадут в массив родителя
	if (!Object.hasOwn(target.constructor, '__noSerializeFields')) {
		target.constructor.__noSerializeFields = [];
	}

	/** Убираем приватный underscore _ , чтобы имя совпадало с публичным геттером */

	const publicName = propertyKey.startsWith('_')
		? propertyKey.slice(1)
		: propertyKey;
	target.constructor.__noSerializeFields.push(publicName);
}

export default NoSerialize;